import React from 'react';
import { ToastContainer } from 'react-toastify';
import { Slide } from 'react-toastify';
import styled from 'styled-components';

require('react-toastify/dist/ReactToastify.css');

export const WrappedToastContainer = ({ className, ...rest }) => (
  <div className={className}>
    <ToastContainer
      autoClose={4000}
      closeButton={false}
      position='bottom-center'
      transition={Slide}
      hideProgressBar={true}
      {...rest}
    />
  </div>
);

export default styled(WrappedToastContainer)`
  .Toastify__toast {
    border-radius: 6px;
    font-family: ${props => props.theme.font.primary};
    margin: 0;
    min-height: 40px;
    padding: ${props => props.theme.gutter};
  }
  .Toastify__toast--success {
    background: ${props => props.theme.bg};
    color: ${props => props.theme.enigmaDark};
  }
  .Toastify__toast-body {
    align-content: center;
    align-items: center;
    display: flex;
    font-size: 14px;
    justify-content: center;
    margin: 0;
    padding-bottom: 2px;
    width: 100%;
  }
  .Toastify__progress-bar {
    background-color: ${props => props.theme.primary};
    height: 2px;
  }
`;
